import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ user, subscriptions }) {
    this.user = user;
    this.subscriptions = subscriptions;

    this.listenTo(this.user, 'change', this.render);
    this.listenTo(this.subscriptions, 'sync', this.render);
  },

  context() {
    const pricePerShipment = (parseFloat(this.user.get('price_per_shipment')) * 100).toFixed(1);
    const [cents, subcents] = pricePerShipment.split('.');
    const pricePerShipmentFormatted = cents + (subcents === '0' ? '' : `.${subcents}`);

    return {
      pricePerShipmentFormatted,
      showPricePerShipment: !this.subscriptions.hasActiveShippingSub(),
      firstFetchSuccess: this.subscriptions.firstFetchSuccess && this.user.firstFetchSuccess,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/price_per_shipment/index.js